// Real Alumni Association governance. Charter, history and the Deans come from
// bietdvg.edu/alumini/alumni_association (fetched 2026-08-02); the executive
// committee and the department coordinator table were replaced from the
// Association's own return, BIET_RESOURCE/Alumni.docx (2026-09-04). Dean-Alumni reuses the About > Deans roster (deans.ts) rather than
// duplicating it — that roster already carries an ingested photo for D12.
import { DEANS } from "./deans";

export interface CommitteeMember {
  name: string;
  title: string;
}

export const HISTORY = {
  established: 1994,
  milestones: [
    { year: "1994", what: "Alumni Association established. First president: Prof. G.S. Shivanna; first secretary: Dr. Sharanaprabhu." },
    { year: "2005", what: "Mr. S.B. Patil assumes the role of secretary." },
    { year: "2009", what: "Mega alumni meet conducted." },
    { year: "2010", what: "Major alumni meet on May 1st draws nationwide participation." },
    { year: "2012", what: "Textile alumni meet, with department heads felicitated." },
  ],
};

export const VISION =
  "To provide a platform that bridges the gap between institute and alumni by enabling systemic collaboration between both entities, leading to the creation of knowledgeable and responsible assets for the institute.";

export const MISSION = [
  "Advise and conduct activities motivating and upgrading student skill sets.",
  "Mentor and channelize student efforts toward better learning opportunities.",
  "Help spread a philanthropic and entrepreneurial mindset among students.",
];

export const OBJECTIVES = [
  "Develop a mutually beneficial environment for lifelong intellectual and emotional relationships.",
  "Create an academia-industry interface for institute brand propagation.",
];

export const EXECUTIVE_COMMITTEE: {
  president: CommitteeMember;
  vicePresident: CommitteeMember;
  secretary: CommitteeMember;
  jointSecretary: CommitteeMember;
  treasurer: CommitteeMember;
  /** The return's own heading for the remaining office-bearers. */
  directors: CommitteeMember[];
} = {
  president: { name: "Dr. H.B. Aravind", title: "Principal, BIET" },
  vicePresident: { name: "Prof. M.E. Ashalatha", title: "Professor, Electronics & Communication Engineering" },
  secretary: { name: "M.C. Patel", title: "Lecturer, Textile Technology" },
  // Not in the staff record; the return gives no designation, so none is shown.
  jointSecretary: { name: "G.B. Suresh Kumar", title: "" },
  treasurer: { name: "Dr. K.C. Devendrappa", title: "Professor, Mechanical Engineering" },
  directors: [
    { name: "Dr. Suresh S", title: "Professor, Civil Engineering" },
    { name: "Dr. G. Manavendra", title: "Professor & Head, Mechanical Engineering" },
    { name: "Sheik Imran", title: "Assistant Professor, AI & Machine Learning" },
    // The return spells this "Ksthigi Basavaraj"; bietdvg.edu spells it Kshitij,
    // which is the spelling kept here. Same person, external member.
    { name: "Kshitij Basavaraj", title: "Managing Director, PSK Pharma, Harihar" },
    // Not in the staff record — an external member, like Kshitij Basavaraj.
    { name: "Smt. Yasha Dinesh", title: "" },
    { name: "Dr. Nirmala C.R.", title: "Professor & Head, Computer Science & Engineering" },
  ],
};

export const DEAN_ALUMNI = DEANS.find((d) => d.dNo === "D12")!;
export const DEAN_ALUMNI_EMAIL = "kcdbiet16@gmail.com";


export interface AlumniCoordinator {
  department: string;
  name: string;
  email?: string;
  /**
   * NOT RENDERED. The return supplies a mobile for each coordinator, but these
   * are personal numbers and the page deliberately does not publish them
   * (2026-09-04) — email is the public route. Kept so the contact the
   * Association gave us is not lost, the way staff.ts keeps its own record
   * without printing it.
   */
  phone?: string;
}

/**
 * Department alumni coordinators, in the order the return numbers them.
 * Department names are the site's canonical ones (departments.ts) rather than the
 * return's shorthand, so the table reads consistently with the rest of the site.
 *
 * Every name here except the two external committee members resolves to a record
 * in staff.ts; three differ in spelling from the return and follow the staff
 * record: Nandeesh R S (return: "Nandish"), Chethan B K ("Chetan") and
 * Bharath H C ("Bharath H").
 */
export const DEPARTMENT_COORDINATORS: AlumniCoordinator[] = [
  { department: "Civil Engineering", name: "Dr. Raghu M E", email: "raghukakkaragolla@bietdvg.edu", phone: "97416 46266" },
  { department: "Mechanical Engineering", name: "Dr. Vinayaka Patil A B", email: "abvinayakapatil@gmail.com", phone: "99643 28348" },
  { department: "Electrical & Electronics Engineering", name: "Dr. Shivakumaraswamy G M", email: "gms20mar@gmail.com", phone: "95906 21959" },
  { department: "Textile Technology", name: "Nandeesh R S", email: "24nandeesh@gmail.com", phone: "88923 98246" },
  { department: "Electronics & Communication Engineering", name: "Bhagya Shanthakumar", email: "bhagyas@bietdvg.edu", phone: "98441 24330" },
  { department: "Computer Science & Engineering", name: "Nomitha Chawla", email: "nomitha@bietdvg.edu", phone: "88848 86448" },
  { department: "Information Science & Engineering", name: "Dr. N.S. Patil", email: "patilbathi@gmail.com", phone: "98868 40401" },
  { department: "Chemical Engineering", name: "Shashikala K J", email: "shashikalakj@bietdvg.edu", phone: "99643 82484" },
  { department: "Biotechnology", name: "Bilwashri H", email: "bt_bilwashri@bietdvg.edu", phone: "96061 27087" },
  { department: "Computer Science & Business Systems", name: "Chethan B K", email: "chethanbiet2024@gmail.com", phone: "88800 17558" },
  { department: "Computer Science & Engineering (Data Science)", name: "Bharath H C", email: "bhc@bietdvg.edu", phone: "94499 30921" },
  { department: "Computer Science & Design", name: "Shadaksharaiah C", email: "cshadaksharaiah@bietdvg.edu", phone: "98800 42984" },
  { department: "Artificial Intelligence & Machine Learning", name: "Dr. Sheik Imran", email: "sheikimran@bietdvg.edu", phone: "99451 19199" },
  { department: "Master of Computer Applications", name: "Pooja K N", email: "poojakn531@gmail.com", phone: "90086 35312" },
];
